import React from 'react';
import { BUTTON_GO_TO_PAYMENT } from '../../../brands/default/content/components/checkout';
import { scrollToPayment } from '../../../helpers/payment';
import CTAButton from '../../_generic/button/CTAButton';

const ButtonGoToPayment = () => {
  return (
    <CTAButton className="full-width" onClick={scrollToPayment}>
      {BUTTON_GO_TO_PAYMENT}
    </CTAButton>
  );
};

export default ButtonGoToPayment;
